<template>
  <div class="tw-h-full">
    <div
      class="tw-h-[50px] tw-w-full tw-relative tw-z-10 tw-bg-white tw-border-b tw-border-solid tw-border-gray-200 tw-flex tw-items-center tw-justify-between tw-px-4">
      <h2 class="tw-font-semibold tw-text-lg">{{ $t('pages.dashboard.followup_manager_overview') }}</h2>
      <div>
        <a-button v-if="false" @click="show.filters = !show.filters" intent="simple" class="tw-py-0 !tw-min-h-[30px] "
          left-icon="lucide:list-filter">
          <span>{{ $t('buttons.filter') }}</span>
        </a-button>
      </div>
    </div>

    <div :class="[show.filters ? 'tw-grid-rows-[1fr]' : 'tw-grid-rows-[0fr]']"
      class="tw-grid tw-duration-300 tw-transition-all tw-relative tw-z-10">
      <div class="tw-overflow-hiddenx tw-col-span-1">
        <div
          class="tw-h-[200px]x tw-bg-white tw-w-full -tw-translate-y-1 tw-border-b tw-border-solid tw-border-gray-200 tw-p-4">
          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4">
            <FollowupFilter />
            <ReconfirmedAtFilter />
          </div>
        </div>
      </div>
    </div>

    <div class="tw-p-2 tw-grid tw-grid-cols-12 tw-gap-2">
      <div class="tw-col-span-12">
        <FollowupManagerPerformanceWidget />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <ReconfirmationChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <DeliveryChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <DailyTreatedFollowupsChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <DailyReconfirmedFollowupsChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <DailyFollowupCallsChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <DailyAssignedFollowupsChart />
      </div>
      <div class="tw-col-span-12">
        <TopProductsWidget />
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, provide } from 'vue';
import FollowupFilter from '@/components/dashboard/followup-manager/filters/FollowupFilter.vue';
import FollowupManagerPerformanceWidget from '@/components/dashboard/followup-manager/FollowupManagerPerformanceWidget.vue';
import DailyTreatedFollowupsChart from '@/components/dashboard/followup-manager/charts/DailyTreatedFollowupsChart.vue';
import DailyReconfirmedFollowupsChart from '@/components/dashboard/followup-manager/charts/DailyReconfirmedFollowupsChart.vue';
import DailyFollowupCallsChart from '@/components/dashboard/followup-manager/charts/DailyFollowupCallsChart.vue';
import DailyAssignedFollowupsChart from '@/components/dashboard/followup-manager/charts/DailyAssignedFollowupsChart.vue';
import TopProductsWidget from '@/components/dashboard/followup-manager/TopProductsWidget.vue';
import ReconfirmationChart from '@/components/dashboard/followup-manager/charts/ReconfirmationChart.vue';
import DeliveryChart from '@/components/dashboard/followup-manager/charts/DeliveryChart.vue';
import ReconfirmedAtFilter from '@/components/dashboard/followup-manager/filters/ReconfirmedAtFilter.vue';

const show = ref({ filters: false });
const filters = ref({ 
  followup_id: [] // Default to empty array which means "All"
});

provide('filters', filters);
provide('filter', () => null);
provide('register', () => null);

</script>

<style></style>